import React from "react";
import { Star, Pencil } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

const QuestionCard = ({
  question,
  isSelected,
  onSelect,
  onToggleFavourite,
  onEdit,
}) => {
  const text = question.questionText || "—";
  const type = question.questionType || "—";
  const category = question.category || "—";
  const isFavourite = question.isFavourite ?? false;
  const usedInCount = question.usageCount ?? 0;

  return (
    <div
      onClick={() => onSelect?.(question)}
      className={cn(
        "relative flex flex-col justify-between p-4 rounded-lg",
        "cursor-pointer transition-all duration-150",
        // ── base ──
        "bg-white dark:bg-gray-800",
        // ── border states ──
        isSelected
          ? "border-2 border-emerald-500 dark:border-emerald-400"
          : "border border-gray-200 hover:border-gray-300 hover:shadow-sm dark:border-gray-700 dark:hover:border-gray-500",
      )}
    >
      {/* ── Top Row ── */}
      <div className="flex items-start justify-between mb-4">
        <span
          className="text-[11px] font-semibold uppercase tracking-widest
                                  text-muted-foreground dark:text-gray-400"
        >
          {category}
        </span>

        <button
          onClick={(e) => {
            e.stopPropagation();
            onToggleFavourite?.(question._id);
          }}
          className="p-0.5 rounded transition-colors"
        >
          <Star
            className={cn(
              "h-4 w-4 transition-colors",
              isFavourite
                ? "fill-yellow-400 text-yellow-400"
                : "text-gray-300 hover:text-yellow-400 dark:text-gray-600 dark:hover:text-yellow-400",
            )}
          />
        </button>
      </div>

      {/* ── Question Text ── */}
      <p
        className="text-sm font-medium leading-snug flex-1 mb-6
                           text-gray-800 dark:text-gray-100"
      >
        {text}
      </p>

      {/* ── Bottom Row ── */}
      <div className="flex items-center justify-between gap-2">
        {/* Type badge */}
        <span
          className="rounded-full px-2 py-1 text-[11px] font-semibold capitalize
                                  bg-primary/10 text-primary
                                  dark:bg-primary/20 dark:text-primary"
        >
          {type?.replace(/_/g, " ") || "text"}
        </span>

        {/* Used in count */}
        <span
          className="text-xs flex-1 text-center
                                  text-muted-foreground dark:text-gray-500"
        >
          Used in {usedInCount} surveys
        </span>

        {/* Edit button */}
        <Button
          variant="ghost"
          size="icon"
          onClick={(e) => {
            e.stopPropagation();
            onEdit?.(question);
          }}
          className="hover:bg-gray-100 dark:hover:bg-gray-700"
        >
          <Pencil
            className="h-4 w-4
                                       text-gray-400 dark:text-gray-500"
          />
        </Button>
      </div>
    </div>
  );
};

export default QuestionCard;
